export enum AuthEvents {
  LOGIN = "auth_login",
  LOGOUT = "auth_logout",
  LOGIN_SUCCESS = "auth_login_success",
  LOGIN_FAILURE = "auth_login_failure",
  SIGNUP = "auth_signup",
  SIGNUP_SUCCESS = "auth_signup_success",
  SIGNUP_FAILURE = "auth_signup_failure",
  LOGIN_ATTEMPTED = "auth_login_attempted",
  LOGIN_SUCCEEDED = "auth_login_succeeded",
  LOGIN_FAILED = "auth_login_failed",
  LOGOUT_ATTEMPTED = "auth_logout_attempted",
  LOGOUT_COMPLETED = "auth_logout_completed",
  USER_IDENTIFIED = "auth_user_identified",
  SESSION_EXPIRED = "auth_session_expired",
}